import { render, staticRenderFns } from "./FormInputGroupButton.vue?vue&type=template&id=4a6408f2&"
import script from "./FormInputGroupButton.vue?vue&type=script&lang=js&"
export * from "./FormInputGroupButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports